import Cookies from "js-cookie";

import { parentDomainCookieOptions } from "shared/cookies";

import { getSignupLanguage } from "./get-signup-language";

// Read by the backend SSO strategies when the redirect creates a new account.
const SIGNUP_LANGUAGE_COOKIE = "dash_signup_language";

export const writeSignupLanguageCookie = () => {
  Cookies.set(
    SIGNUP_LANGUAGE_COOKIE,
    getSignupLanguage(),
    parentDomainCookieOptions(1)
  );
};
